import React, { Fragment } from "react";
import styled from "styled-components";
import {
  ControlGroup,
  Button,
  Menu,
  Popover,
  ArrowDropdownDown,
  spacing,
  palette,
  layer,
} from "@conserveit/blocks";
import { SnoozeMenu } from "../../../containers/SnoozeMenu";

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: ${spacing.ultraLoose};
  background: ${palette.neutral2};
  cursor: default;
  height: 40px;
  z-index: ${layer.first};
`;

const Snooze = styled(Button)`
  margin-left: ${spacing.default};
`;

const EquipActions = ({ linkTicket, createTicket, equipRuleIds, isHidden }) => (
  <Wrapper hidden={isHidden}>
    <ControlGroup tight>
      <Button wafer additive appearance="subdued" onClick={createTicket}>
        Add Action
      </Button>
      <Button wafer primary appearance="subdued" onClick={linkTicket}>
        Associate with Action
      </Button>
    </ControlGroup>
    <Menu>
      {({ isOpen, toggle, close }) => (
        <Fragment>
          <Snooze wafer appearance="outline" onClick={toggle}>
            Snooze <ArrowDropdownDown tiny />
          </Snooze>
          {isOpen && (
            <Popover right>
              <SnoozeMenu
                showUnsnooze
                equipRuleIds={equipRuleIds}
                onClick={close}
              />
            </Popover>
          )}
        </Fragment>
      )}
    </Menu>
  </Wrapper>
);

EquipActions.propTypes = {};

export default EquipActions;
